import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const cargoGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // cargoGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.CARGO) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const cargoShipment = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // cargoShipment is 2
    if (appID !== constAppID.CARGO) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'cargoQuote' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  }
}

export const cargoClause = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // cargoClause is 3
    if (appID !== constAppID.CARGO) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 3) {
      if (quoteLifeCycle === 1) {
        next({ name: 'cargoQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'cargoQuoteShipment' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  }
}

export const cargoInsured = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // cargoInsured is 4
    if (appID !== constAppID.CARGO) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 4) {
      if (quoteLifeCycle === 1) {
        next({ name: 'cargoQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'cargoQuoteShipment' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'cargoQuoteClause' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  }
}

export const cargoPremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // cargoPremium is 5
    if (appID !== constAppID.CARGO) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 5) {
      if (quoteLifeCycle === 1) {
        next({ name: 'cargoQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'cargoQuoteShipment' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'cargoQuoteClause' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'cargoQuoteInsured' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
